import React, { useState, useEffect, useRef } from 'react';

const AddIngredientModal = ({ isOpen, onClose, onSave, editingIngredient }) => {
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const inputRef = useRef(null);
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      if (editingIngredient) {
        setName(editingIngredient.name);
      } else {
        setName('');
      }
      setError('');
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 0);
    }
  }, [editingIngredient, isOpen]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      } else if (event.key === 'Tab' && modalRef.current) {
        const focusableElements = Array.from(modalRef.current.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )).filter(el => el.offsetParent !== null);

        if (focusableElements.length === 0) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        const currentIndex = focusableElements.indexOf(document.activeElement);

        event.preventDefault();

        if (event.shiftKey) {
          if (currentIndex <= 0) {
            lastElement.focus();
          } else {
            focusableElements[currentIndex - 1].focus();
          }
        } else {
          if (currentIndex === -1 || currentIndex === focusableElements.length - 1) {
            firstElement.focus();
          } else {
            focusableElements[currentIndex + 1].focus();
          }
        }
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, editingIngredient, onClose]);

  if (!isOpen) return null;

  const handleSave = async (andAnother) => {
    if (!name) {
      setError('Ingredient name cannot be empty');
      return;
    }
    const response = await onSave({ ...editingIngredient, name }, andAnother);
    if (response && response.error) {
      setError(response.error);
    } else {
      setError('');
      if (andAnother) {
        setName('');
        inputRef.current.focus();
      } else {
        onClose();
      }
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" ref={modalRef}>
        <div className="modal-header">
          <h2><i className="material-icons" style={{ marginRight: '5px', verticalAlign: 'top' }}>kitchen</i>{editingIngredient ? 'Edit Ingredient' : 'Add Ingredient'}</h2>
          <button title="Close" onClick={onClose} className="icon-button close-button"><i className="material-icons">close</i></button>
        </div>
        <div className="modal-body">
        {error && <p className="error-message">{error}</p>}
        <div className="search-input-container">
          <input
            ref={inputRef}
            type="text"
            placeholder="Ingredient Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSave(!editingIngredient)}
          />
          {name && <button title="Clear name" onClick={() => { setName(''); inputRef.current.focus(); }} className="clear-input-button"><i className="material-icons">close</i></button>}
        </div>
        </div>
        <div className="modal-footer">
          {!editingIngredient && <button title="Save and add another" onClick={() => handleSave(true)}>Save and another</button>}
          <button title="Save and close" onClick={() => handleSave(false)}>Save and close</button>
          <button title="Cancel" onClick={onClose} className="cancel-button">Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default AddIngredientModal;